<template>
  <calendar-view></calendar-view>
</template>

<script>
import CalendarView from "../components/agenda/calendar-view/CalendarView.vue";
export default {
  components: { CalendarView },
  name: "Calendar",
};
</script>

<style scoped>
::v-deep .container--fluid {
  padding: 0px !important;
}
</style>